import { isApiError } from "@xplatform/platform";
import { REVIEW_ERROR_CODES } from "@models/review";

/**
 * Maps a thrown error to an i18n key for a clear user message. The review
 * routes return 403 (missing permission) and 409 with a stable `error_code`
 * (`image_already_decided` / `review_pending` / `run_not_generated`);
 * 422 is a validation failure. Branch on `status` / `errorCode`, never on the
 * message text (which can be backend prose).
 */
export function errorMessageKey(error: unknown): string {
  if (!isApiError(error)) return "review.errors.unknown";

  if (error.status === 403) return "review.errors.forbidden";
  if (error.status === 422) return "review.errors.validation";

  if (error.status === 409) {
    switch (error.errorCode) {
      case REVIEW_ERROR_CODES.imageAlreadyDecided:
        return "review.errors.alreadyDecided";
      case REVIEW_ERROR_CODES.reviewPending:
        return "review.errors.reviewPending";
      case REVIEW_ERROR_CODES.runNotGenerated:
        return "review.errors.runNotGenerated";
      case REVIEW_ERROR_CODES.imageNotRegenerable:
        return "review.errors.imageNotRegenerable";
      default:
        return "review.errors.conflict";
    }
  }

  return "review.errors.unknown";
}
